/* Bocetta v12: bandera del cintillo, banderas del selector de país, descripción del color elegido
   y código del newsletter. Script clásico, sin dependencias.
   v1.3 (2026-10): se quitó la barra de envío gratis del carrito y las líneas «Envío gratis a partir de…»:
   la tienda ya no ofrece envío gratis. El envío se cobra por peso en el checkout.
   v1.4 (2026-10): la bandera usa 24 franjas finas en vez de 10 para que la onda se vea continua, sin escalones. */
(() => {
  const B = window.BOCETTA || {};
  const TXT = {"en": {"codigo": "Your 5% code for your first order: [codigo]"}, "es": {"codigo": "Tu código de 5% para tu primera compra: [codigo]"}, "fr": {"codigo": "Votre code de 5 % pour votre première commande : [codigo]"}, "de": {"codigo": "Dein 5-%-Code für die erste Bestellung: [codigo]"}, "it": {"codigo": "Il tuo codice del 5% per il primo ordine: [codigo]"}};
  const idioma = String(B.idioma || document.documentElement.lang || 'en').slice(0, 2);
  const T = TXT[idioma] || TXT.en;
  const CODIGO = 'HOLA5';

  // Sin envío gratis: cualquier línea vieja «Envío gratis a partir de…» o barra que quede en el HTML se esconde.
  function esconderEnvioGratis(raiz = document) {
    raiz.querySelectorAll('[data-bc-umbral], [data-bc-barra]').forEach((el) => { if (!el.hidden) el.hidden = true; });
  }

  // ---------- Verde, blanco y rojo en todo el cintillo ----------
  // 24 franjas finas, cada una un poco desfasada: el borde ondula de forma continua, sin escalones visibles.
  function bandera() {
    const barra = document.querySelector('#header-group .announcement-bar');
    if (!barra || barra.querySelector('.bc-ondas')) return;
    const capa = document.createElement('div');
    capa.className = 'bc-ondas';
    capa.setAttribute('aria-hidden', 'true');
    const n = 24;
    const paso = 2.52 / n;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('span');
      s.style.setProperty('--bc-d', -(i * paso).toFixed(3) + 's');
      capa.appendChild(s);
    }
    barra.prepend(capa);
  }

  // ---------- Banderas en el selector de país ----------
  function banderasSelector() {
    if (!B.banderas) return;
    document.querySelectorAll('.localization-form__list-item[data-value]').forEach((li) => {
      if (li.querySelector('.bc-bandera-pais')) return;
      const url = B.banderas[li.dataset.value];
      if (!url) return;
      const img = document.createElement('img');
      img.className = 'bc-bandera-pais';
      img.src = url; img.alt = ''; img.width = 22; img.height = 16; img.loading = 'lazy';
      const nombre = li.querySelector('.country');
      if (nombre) nombre.before(img); else li.prepend(img);
    });
    // México siempre primero en la lista
    document.querySelectorAll('.localization-form__list').forEach((lista) => {
      const mx = lista.querySelector('.localization-form__list-item[data-value="MX"]');
      const primera = lista.querySelector('ul');
      if (!mx || !primera) return;
      const primerPais = primera.querySelector('.localization-form__list-item[data-value]');
      if (primerPais !== mx) primera.insertBefore(mx, primerPais || primera.firstChild);
    });
  }

  // ---------- Descripción del color elegido ----------
  function mostrarColor(valor) {
    const h = String(valor || '').toLowerCase().trim();
    document.querySelectorAll('bocetta-color-detalle').forEach((caja) => {
      const paneles = caja.querySelectorAll('[data-bc-color]');
      if (![...paneles].some((p) => p.dataset.bcColor === h)) return;
      paneles.forEach((p) => { p.hidden = p.dataset.bcColor !== h; });
    });
  }

  // ---------- Código del newsletter tras suscribirse ----------
  function codigoBoletin() {
    document.querySelectorAll('[id^="Email-signup__message-success"]').forEach((m) => {
      if (m.querySelector('.bc-codigo')) return;
      const p = document.createElement('p');
      p.className = 'bc-codigo';
      p.textContent = T.codigo.replace('[codigo]', CODIGO);
      m.appendChild(p);
    });
  }

  function iniciar() {
    bandera();
    banderasSelector();
    esconderEnvioGratis();
    codigoBoletin();
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t instanceof HTMLInputElement && t.type === 'radio' && t.closest('variant-picker')) mostrarColor(t.value);
    });
    let espera = 0;
    new MutationObserver(() => {
      clearTimeout(espera);
      espera = setTimeout(() => {
        esconderEnvioGratis();
        banderasSelector();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
